import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Crown, Sparkles, Check, ArrowLeft } from 'lucide-react';

export default function UpgradePage() {
  const location = useLocation();
  const navigate = useNavigate();
  const feature = location.state?.feature || 'recursos Premium';

  const premiumFeatures = [
    'Cafeteria Best Seller - Converse com o conselho literário',
    'Emulador Acelerador - Escrita com apoio inteligente de IA',
    'Empresário Literário - Transforme sua escrita em valor',
    'Time Literário Ativo - Agentes especializados',
    'Análises avançadas de progresso',
    'Suporte prioritário',
  ];

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        {/* Botão Voltar */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-muted-foreground hover:text-foreground mb-6 transition-colors"
        >
          <ArrowLeft size={18} />
          <span>Voltar</span>
        </button>

        {/* Card Principal */}
        <div className="bg-card border border-border rounded-2xl p-8 text-center">
          {/* Ícone Crown */}
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-amber-400 to-orange-500 flex items-center justify-center shadow-lg shadow-amber-500/30">
            <Crown size={40} className="text-white" />
          </div>

          {/* Título */}
          <h1 className="text-2xl font-serif text-foreground mb-2">
            Desbloqueie o <span className="text-amber-500">Premium</span>
          </h1>
          
          {/* Subtítulo */}
          <p className="text-muted-foreground mb-6">
            Você tentou acessar <span className="font-semibold text-amber-600">{feature}</span>
          </p>

          {/* Lista de Benefícios */}
          <div className="text-left bg-amber-500/5 rounded-xl p-5 mb-6 border border-amber-500/10">
            <p className="text-sm font-semibold text-amber-700 dark:text-amber-400 mb-3 flex items-center gap-2">
              <Sparkles size={16} />
              Benefícios Premium
            </p>
            <ul className="space-y-2">
              {premiumFeatures.map((feature, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Check size={16} className="text-amber-500 flex-shrink-0 mt-0.5" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Botão de Upgrade */}
          <button
            onClick={() => {
              // Aqui será integrado com Stripe futuramente
              alert('Integração com pagamento em breve!');
            }}
            className="w-full bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white font-semibold py-3 px-6 rounded-lg transition-all duration-200 transform hover:scale-[1.02] shadow-lg shadow-amber-500/30"
          >
            Fazer Upgrade para Premium
          </button>

          {/* Nota */}
          <p className="text-xs text-muted-foreground mt-4">
            Cancele a qualquer momento. Sem compromisso.
          </p>
        </div>
      </div>
    </div>
  );
}
